module.exports = __webpack_public_path__ + "static/media/Button_default_341px.e776254f.svg";